import {Navigate, useOutlet} from "react-router-dom";
import {useAuthContext} from "../../contexts/auth-context";
import React from "react";
import {Layout} from "../layout";

export const ProtectedRoute = () => {

  const {isAuthenticated, logout} = useAuthContext();
  const outlet = useOutlet();

  function isExpired(token: string | null): boolean {
    if (token !== null) {
      const expiry = (JSON.parse(atob(token.split(".")[1]))).exp;
      return (Math.floor((new Date).getTime() / 1000)) >= expiry;
    }
    return true;
  }

  if (!isAuthenticated) {
    return <Navigate to="/"/>;
  } else if (isExpired(localStorage.getItem("token"))) {
    logout();
  }
  return (
    <>
      <Layout>
          {outlet}
      </Layout>
    </>
  );
};
